import { render, staticRenderFns } from "./UnitDetailTable.vue?vue&type=template&id=d2d3b97c&scoped=true&"
import script from "./UnitDetailTable.vue?vue&type=script&lang=ts&"
export * from "./UnitDetailTable.vue?vue&type=script&lang=ts&"
import style0 from "./UnitDetailTable.vue?vue&type=style&index=0&id=d2d3b97c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d3b97c",
  null
  
)

export default component.exports